import React from 'react'

interface LabelProps {
  name: string
  content: string | React.ReactElement
  className?: string
}

const Label: React.FC<LabelProps> = ({ name, content, className }) => {
  return (
    <>
      {typeof content === 'string' ? (
        <label htmlFor={name} className={`${className} text-label-neutral`}>
          {content}
        </label>
      ) : (
        <>{content}</>
      )}
    </>
  )
}

export default Label
